"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var view = tslib_1.__importStar(require("@catalytic/view"));
var DEFAULT_PROPS = {
    get editor() {
        throw new Error('Missing <ViewContext />');
    },
    set editor(_types) {
        throw new Error('Missing <ViewContext />');
    },
    get reader() {
        throw new Error('Missing <ViewContext />');
    },
    set reader(_types) {
        throw new Error('Missing <ViewContext />');
    }
};
var ViewContext = React.createContext(DEFAULT_PROPS);
exports.default = ViewContext;
//# sourceMappingURL=context.js.map